import { Component, ElementRef, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import swal from 'sweetalert2';
import { ExcelService } from 'src/app/services/excel.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import * as _ from 'lodash';
import { RoleDirective } from 'src/app/views/layout/directives/role.directive';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { EdithiredatedialogComponent } from './edithiredatedialog.component';
import { ExtendcashdialogComponent } from './extendcashdialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { BookingStatusType } from 'src/enum/bookingstatustype';



@Component({
  selector: 'app-viewbooking',
  templateUrl: './viewbooking.component.html',
  styleUrls: ['./viewbooking.component.scss']
})
export class ViewbookingComponent implements OnInit {
  controlAccess: any;
  data: any = [];
  roleId: number;
  routeParams: any;
  id: number;
  editBookedhire: any;
  getByIdData: any;
  soloHireHrs: any;
  getallData: any;
  totalHireHours: any;
  getactionInfo: any;
  actionInfo = 0;
  submitbtn: string;
  bookingId: any;
  languageType: any;
  bookedHireData: any = [];
  formEditMode = true;
  bookingHistorydata = [];
  totalNoOfHours: any;
  remainingHours: any;
  hoursTotal: any = [];
  SplitTotalbookedHrs: any[];
  totalNoOfallocatedHours: any;
  cashPayment: boolean = false;
  successPayment: any[];

  bookingHistorydataSource = new MatTableDataSource(this.bookingHistorydata);
  bookingHistorydisplayedColumns: string[] = [
    // 'actions',
    'paymentDate',
    'paymentMethod',
    'paymentReceiptNo',
    'trasanctionRefNo',
    'totalHours',
    'totalAmount',
    'bookingType',
  ];


  bookingDetailViewdata = [];
  bookingDetailViewdataSource = new MatTableDataSource(this.bookingDetailViewdata);
  bookingDetailViewdisplayedColumns: string[] = [
    // 'actions',
    'BookedDate',
    'allocatedDate',
    'nofohours',
    'nofoallhours',
    'regno',
    'DNMN'
  ];

  public StatusEnumType = BookingStatusType;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  hireAmount: number;


  constructor(public navigationService: NavigationService,
    private userSessionService: UserSessionService,
    private excelService: ExcelService,
    private translate: TranslateService,
    private subDivisionService: SubDivisionService,
    private cashBookingService: CashBookingService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewbookingComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToView: any) {
    // this.controlAccess  = this.userSessionService.getPageUrl(this.router.url);
    //this.roleId = this.userSessionService.roleId();

    this.languageType = this.userSessionService.getLanguageType();
    this.data = [];
    this.routeParams = route.snapshot.params;
    this.id = +this.routeParams.id;
    // if (this.id === 0) {
    //   this.submitbtn = 'Save';
    // } else {
    //   this.submitbtn = 'Save';
    // }
    // if (this.actionInfo == 1) {
    //   this.formEditMode = false
    // }
    this.dataRecievedToView.selectedData
    //  this.actionInfo = this.routeParams.actionInfo
  }

  ngOnInit(): void {
    this.data = [];

    this.getFileToView();
    this.get(true)
  }
  getFileToView() {
    if (this.dataRecievedToView.selectedData) {
      // this.data = this.dataRecievedToView.selectedData;
    }
  }
  onCancel(isProceed) {
    this.dialogRef.close(isProceed);
  }
  get(refresh: boolean) {
    const data = {
      bookingId: this.dataRecievedToView.selectedData,
      langType: this.languageType
    }
    this.cashBookingService.getCashBookingByBookingId(data, refresh).subscribe(result => {
      this.bookedHireData = [];
      this.bookedHireData = result;
      if (result.bookedAllocationViewModel) {
        this.data.mhireAllocationViewModel = {};
        this.data.mhireAllocationViewModel = result.bookedAllocationViewModel;
        this.bookingDetailViewdata = result.bookedAllocationViewModel;
        this.bookingDetailViewdataSource = new MatTableDataSource(this.bookingDetailViewdata);
        this.bookingDetailViewdataSource.sort = this.sort;
        this.bookingDetailViewdataSource.paginator = this.paginator;

        let hireDates = [];
        result.bookedAllocationViewModel.forEach(element => {
          hireDates.push(element.hireHrs)
        });
        result.bookedAllocationViewModel.forEach(element => {
          this.hoursTotal.push(element.hireHrs)
        });
        this.SplitTotalbookedHrs = hireDates;
        this.totalNoOfHours = hireDates.reduce((a, b) => a + b, 0)

        let allocatedDatehours = [];
        let filterBystatusType = [];
        filterBystatusType = result.bookedAllocationViewModel.filter(x => x.statusType === 1);
        filterBystatusType.forEach(element => {
          allocatedDatehours.push(element.allocatedHours)
        });
        this.totalNoOfallocatedHours = allocatedDatehours.reduce((a, b) => a + b, 0)

        this.remainingHours = this.totalNoOfHours - this.totalNoOfallocatedHours


      } if (result.mhireBookingDetailViewModel.length > 0) {
        this.data.mhireBookingDetailViewModel = []
        this.data.mhireBookingDetailViewModel = result.mhireBookingDetailViewModel;
      } if (result.mhireBookingImplementViewModel.length > 0) {
        this.data.mhireBookingImplementViewModel = [];
        this.data.mhireBookingImplementViewModel = result.mhireBookingImplementViewModel;
      } if (result.mhirePaymentHistoryViewModel.length > 0) {
        this.data.mhirePaymentHistoryViewModel = [];
        this.data.mhirePaymentHistoryViewModel = result.mhirePaymentHistoryViewModel;
        this.successPayment = [];
        this.successPayment = result.mhirePaymentHistoryViewModel.filter(e =>e.paymentStatusType === 1 )
        this.hireAmount = _.sumBy(this.successPayment, 'amount');
        this.bookingHistorydata = result.mhirePaymentHistoryViewModel;
        this.bookingHistorydataSource = new MatTableDataSource(this.bookingHistorydata);
        if (this.bookingHistorydata && this.bookingHistorydata[0].paymentModeType == 'CASH') {
          this.cashPayment = true
        } else {
          this.cashPayment = false
        }
        this.bookingHistorydataSource.sort = this.sort;
        this.bookingHistorydataSource.paginator = this.paginator;
      }
      this.data.farmFullAddress = result.farmFullAddress;
      this.data = result;
    })
  }
  bookingHistoryapplyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.bookingHistorydataSource.filter = filterValue.trim().toLowerCase();
    if (this.bookingHistorydataSource.paginator) {
      this.bookingHistorydataSource.paginator.firstPage();
    }
  }
  bookingDetailViewapplyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.bookingDetailViewdataSource.filter = filterValue.trim().toLowerCase();
    if (this.bookingDetailViewdataSource.paginator) {
      this.bookingDetailViewdataSource.paginator.firstPage();
    }
  }


  openPopup() {

  }
  close(isProceed) {
    this.dialogRef.close(isProceed);
  }
}
